<main>
    <div class="loginWraper">
        <div class="title" *ngIf="!showOtpFlag&& !setPasswordFlag">
            <h2>OTP તમારા મોબાઈલ નંબર પર મોકલશે</h2>
        </div>
        <form [formGroup]="conatct_number" *ngIf="!showOtpFlag&& !setPasswordFlag">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="મોબાઇલ નંબર" formControlName="contactNumber" maxlength="15" />
                <div *ngIf="submitted && e.contactNumber.errors" class="error-message">
                    <small *ngIf="e.contactNumber.errors?.required" class="text-danger">સંપર્ક નંબર જરૂરી છે.</small>
                </div>
                <div *ngIf="e.contactNumber.errors?.pattern && e.contactNumber.touched" class="error-message">
                    <small *ngIf="e.contactNumber.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
                </div>
                <div *ngIf="e.contactNumber.errors?.minlength && e.contactNumber.touched" class="error-message">
                    <small *ngIf="e.contactNumber.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                        છે.</small>
                </div>
            </div>
            <button type="submit" class="btn-common" (click)="getOtp()">સબમિટ કરો</button>
        </form>
        <form class="form" [formGroup]="otpForm" *ngIf=" showOtpFlag == true">
            <div class="title">
                <h2>{{message}}</h2>
            </div>
            <!-- <div class="title">
                <h2>OTP ચકાસણી</h2>
            </div>
            <div>
                <div class="form-group pos_rel mb-3">
                    <input id="otp" name="otp" type="text" placeholder="OTP" class="form-control lgn_input" required
                        formControlName="otp" maxlength="6"  (keypress)="otpKeyPress($event)">
                    <div *ngIf="otpsubmitted && g.otp.errors">
                        <small *ngIf="g.otp.errors.required" class="text-danger">
                            OTP જરૂરી છે.
                        </small>
                        <small *ngIf="g.otp.errors.minlength" class="text-danger">6 નંબર જરૂરી છે</small>
                    </div>
                    <div *ngIf="g.otp.errors?.pattern && g.otp.touched" class="error-message">
                        <small *ngIf="g.otp.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
                    </div>
                    <div *ngIf="g.otp.errors?.minlength && g.otp.touched" class="error-message">
                        <small *ngIf="g.otp.errors?.minlength" class="text-danger">ઓછામાં ઓછા 6 નંબર જરૂરી
                            છે.</small>
                    </div>
                </div>
            </div>
            <button type="submit" class="btn-common" (click)="verifyOtp()">ચકાસો</button> -->
        </form>
        <form class="form" [formGroup]="passwordForm" *ngIf=" setPasswordFlag == true">
            <div class="title">
                <h2>પાસવર્ડ રીસેટ કરો</h2>
            </div>
            <div>
                <div class="form-group mx-2 pos_rel mb-3  position-relative">
                    <input id="password" name="password1" [type]="showPassword ? 'text' : 'password'"
                        placeholder="પાસવર્ડ" class="form-control lgn_input" formControlName="password" required>
                    
                        <span class="passEye" (click)="password()">
                            <i style="cursor: pointer;"
                                [ngClass]="{'ti ti-eye': showPassword != false, 'ti ti-eye-off': showPassword != true }"></i>
                        </span>
                        
                    <div *ngIf="passwordSubmitted && f.password.errors">
                        <small *ngIf="f.password.errors?.required" class="text-danger">પાસવર્ડ અનિવાર્ય છે.</small>
                        <small *ngIf="f.password.errors?.pattern" class="text-danger">પાસવર્ડ
                            લંબાઈ ઓછામાં ઓછી 8 હોવી જોઈએ
                            પાત્રો
                            અને ઓછામાં ઓછું એક વિશેષ સમાવે છે
                            અક્ષર, સંખ્યાત્મક મૂલ્ય, અપરકેસ
                            અને
                            નાના અક્ષર.</small>
                    </div>
                </div>

                <div class="form-group mx-2 pos_rel mb-3  position-relative">
                    <input id="password2" name="password2" [type]="confirmPassword ? 'text' : 'password'"
                        placeholder="કન્ફર્મ પાસવર્ડ" class="form-control lgn_input" formControlName="cpassword"
                        required="">
                        <span class="passEye" (click)="confirmPwd()">
                            <i style="cursor: pointer;"
                                [ngClass]="{'ti ti-eye': confirmPassword != false, 'ti ti-eye-off': confirmPassword != true }"></i>
                        </span>
                    <div *ngIf="f.cpassword.errors && passwordSubmitted">
                        <small *ngIf="f.cpassword.errors?.required" class="text-danger">પુષ્ટિ કરો પાસવર્ડ જરૂરી છે.</small>
                        <small *ngIf="f.cpassword.errors.mustMatch" class="text-danger">
                            બંને પાસવર્ડ મેળ ખાતા નથી
                        </small>
                    </div>
                </div>
            </div>
            <button class="btn-common" type="submit" (click)="resetPassoword()">પાસવર્ડ રીસેટ કરો</button>
        </form>
    </div>
</main>